import React, { useEffect, useState } from "react";
import "./ProfileNotApproved.css";
import OnboardingHeader from "../../Onboarding/OnboardingHeader";
import Icons from "../../../../../Config/Images";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getLoggedInUserDetailsAPI } from "../../../../../Store/Action/UserAction";
import Header from "../../../Layout/Header/Header";
import HeaderBlack from "../../../WelcomeScreen/Common/Header";

const ProfileNotApproved = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [profileRejectMessages, setProfileRejectMessages] = useState([]);
  // Get the logged-in user details to check their status
  useEffect(() => {
    dispatch(
      getLoggedInUserDetailsAPI({}, (result) => {
        setProfileRejectMessages(
          result?.data?.[0]?.user_profile_review_response
        );
        const userStatus = result?.data?.[0]?.user_status_name;

        if (userStatus === "rejected") {
          // Redirect to the Profile Not Approved page if status is rejected
          navigate("/profile-not-approved", { replace: true });
        } else if (userStatus === "approved") {
          // Redirect to the Profile Verified page if status is approved
          navigate("/profile-verified", { replace: true });
        }
      })
    );
  }, [dispatch, navigate]);

  useEffect(() => {
    localStorage.removeItem("isRefillingOnboardingForm");
  }, []);

  const handleUpdateDetailClick = () => {
    localStorage.removeItem("isRefillingOnboardingFormIsNowInReviewed");
    localStorage.setItem("isRefillingOnboardingForm", "true"); // Store flag in localStorage
    navigate("/onboarding", { replace: true });
  };
  return (
    <>
      {/* <OnboardingHeader /> */}
      <div style={{ position: "sticky", top: 0 }}>
        <div className="section-1-div">
          <HeaderBlack noLoginBtn={true} />
        </div>
      </div>
      <div
        className="profile-not-approved"
        style={{
          backgroundImage: `url(${Icons.loginBgImage})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "100% 100%",
        }}
      >
        <div className="profile-not-approved-card">
          <div className="profile-review-image">
            <img
              src={Icons.not_approved_image}
              alt="Profile Under Review Image"
            />
          </div>
          <div className="profile-review-card-content">
            <div className="timer">
              {/* <span>{timeLeft > 0 ? formatTime(timeLeft) : "00:00"} Min.</span> */}
            </div>
            <h3 className="heading-profile-not-approved">
              Profile Not Approved
            </h3>
            <p className="description">
              Your profile was not accepted due to certain reasons. Please
              review and try again.
            </p>
            <p
              style={{
                textAlign: "left",
                fontFamily: "Poppins,'sans-serif",
                fontWeight: 500,
                fontSize: "16px",
                color: "#000000",
                marginBottom: "10px",
              }}
            >
              Inaccurate Details
            </p>
            <ul className="review-steps">
              {profileRejectMessages?.map((message, index) => (
                <li key={index}>
                  {message.user_profile_review_response_description}
                </li>
              ))}
              {/* <li>Pan Card is missing in PDF.</li>
              <li>A similar profile already exists in our system</li> */}
            </ul>
            <button
              className="thank-you-button"
              onClick={handleUpdateDetailClick}
            >
              Update Detail
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProfileNotApproved;
